export default "immagini/logo-completo.svg"